import axios from 'axios';

const url = '/api/v1/profiles/me/investment_information';

export function setInvestmentThemes(classIds) {
  return axios.post(`${url}/investment_themes`, { asset_class_ids: classIds });
}

export function getInvestmentThemes() {
  return axios.get(url);
}
